<script>
export default {
  name: "FormField",
  props: {
    label: {
      type: String,
    },
    lg: {
      type: Number,
      default: 12,
      required: false
    },
    insideRow: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  computed: {
    containerType() {
      return this.insideRow ? "el-row" : "div";
    }
  },
  render(createElement) {
    return createElement(this.containerType, null, [
      createElement(
        "el-col",
        {
          attrs: {
            lg: this.lg
          }
        },
        [
          createElement(
            "el-form-item",
            {
              attrs: {
                label: this.label
              }
            },
            this.$slots.default
          )
        ]
      )
    ]);
  }
};
</script>

